// Computed live (not cached at module load) since window.app/window.site are
// populated asynchronously by App.js's getWebsiteDefault() — mirrors the
// getBase()/getApp()/getEnv() pattern used in HeirloomChannelsPage.jsx.
export function getEnvoiConfig() {
    const site = window.site || {};
    const app = window.app || {};
    const siteConfig = site.config || (app.defaultSiteSettings && app.defaultSiteSettings.config) || {};
    const bitmovin = (siteConfig.player || {}).bitmovin || {};
    const base = site.screeningApiBaseUrl || '';
    const token =
        (app.storage && app.storage.getItem('token')) ||
        sessionStorage.getItem('token') ||
        localStorage.getItem('token') ||
        '';

    return {
        lambdaUrl: base ? `${base}/` : '',
        appname: app.appName || '',
        environmentVariable: app.appEnvName || '',
        token,
        playerKey: bitmovin.playerKey || '41e9a976-05bc-4a8d-a00a-82d70a2cb733',
        analyticsKey: bitmovin.analyticsKey || 'da0ee94a-b5b5-44c2-866d-11909a34b824',
        defaultLandscape: siteConfig.defaultLandscape || '',
    };
}
